<template>
	<div
		class="flex w-[261px] flex-shrink-0 cursor-pointer flex-col overflow-hidden rounded-rwd-lg border border-n-100 bg-white hover:border-n-950 hover:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)] mdp:w-full"
		@click="handleClick"
	>
		<div class="flex aspect-video flex-col">
			<img
				:src="entry.image_url"
				alt="Coupon Centre"
				class="aspect-video w-full object-cover"
			/>
		</div>
		<footer
			class="flex w-full flex-1 flex-col justify-center bg-white p-8px mdp:p-12px mdl:p-16px lg:p-20px"
		>
			<base-button variant="primary" size="large">
				{{ entry.button_text }}
			</base-button>
		</footer>
	</div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/ui/button/BaseButton.vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

interface CouponCentreEntry {
	image_url: string
	button_text: string
	link_url: string
}

const props = defineProps<{
	entry: CouponCentreEntry
}>()

const handleClick = () => {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.HomePage,
		button_name: 'Go to Coupon Centre',
	})

	window.location.href = props.entry.link_url
}
</script>
